import { render, staticRenderFns } from "./ContactsMenu.vue?vue&type=template&id=b1377baa&scoped=true&"
import script from "./ContactsMenu.vue?vue&type=script&lang=js&"
export * from "./ContactsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContactsMenu.vue?vue&type=style&index=0&id=b1377baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1377baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow,VSpacer})
